$(function(){
  $(".list-logo-carousel").infiniteslide({
    direction:"left",
    clone:10
  });
});
$(function(){
  $(".product-logo-list").infiniteslide({
    direction:"left",
    clone:10
  });
});

$(document).ready(function(){
  $('.btn-play ').click(function() {
    var video_url = $(this).parents('.video-wrapper').data('video');
    $('.video-content').append(`<video playsinline="playsinline" autoplay="autoplay" loop="loop" controls="controls" preload="metadata"><source src="${video_url}" type="video/mp4"></video>`);
    $('html').addClass('mm-open');
    $('.popup-wrapper video').trigger('play');
  });
  $('.contact-watch ').click(function() {
    var video_url = $(this).data('video');
    $('.video-content').append(`<video playsinline="playsinline" autoplay="autoplay" loop="loop" controls="controls" preload="metadata"><source src="${video_url}" type="video/mp4"></video>`);
    $('html').addClass('mm-open');
    $('.popup-wrapper video').trigger('play');
  });
  $('.close-btn').click(function () {
    $('html').removeClass('mm-open');
    $('.video-content').empty();
  });
  $('.popup_bg').click(function () {
    $('html').removeClass('mm-open');
    $('.video-content').empty();
  });
});

function separateReviewCount() {
  // Select the element by its class within the specific structure
  const element = document.querySelector('.wholescale-review-widget-stars-injection .review-count');
  
  if (element) {
    // Get the full text
    const fullText = element.textContent.trim();
    
    // Use a regular expression to separate the number from "Reviews"
    const match = fullText.match(/(\d+)\s*(Reviews)/i);
    
    if (match) {
      const [, number, word] = match;
      
      // Create new elements for the number and the word
      const numberSpan = document.createElement('span');
      numberSpan.textContent = number;
      numberSpan.className = 'review-number';
      
      const wordSpan = document.createElement('span');
      wordSpan.textContent = word;
      wordSpan.className = 'review-word';
      
      // Clear the original content and add the new elements
      element.textContent = '';
      element.appendChild(numberSpan);
      element.appendChild(document.createTextNode(' ')); // Space between number and word
      element.appendChild(wordSpan);
    }
  }
}

function checkAndSeparate() {
  const element = document.querySelector('.wholescale-review-widget-stars-injection .review-count');
  if (element) {
    separateReviewCount();
    // If found and processed, stop the observer
    if (observer) {
      observer.disconnect();
    }
  }
}

// Set up a MutationObserver to watch for changes in the DOM
const observer = new MutationObserver((mutations) => {
  for (let mutation of mutations) {
    if (mutation.type === 'childList') {
      checkAndSeparate();
    }
  }
});

// Start observing the document with the configured parameters
observer.observe(document.body, { childList: true, subtree: true });

// Also try to run it once the DOM is initially loaded
document.addEventListener('DOMContentLoaded', checkAndSeparate);


// Script to hide Grouptify branding
function hideGrouptifyBranding() {
  document.querySelectorAll('div[title="Powered by Grouptify"]').forEach(el => {
    el.remove();
  });
}

hideGrouptifyBranding();

const grouptifyObserver = new MutationObserver(hideGrouptifyBranding);

grouptifyObserver.observe(document.body, {
  childList: true,
  subtree: true
});
// End of script to hide Grouptify branding


// Rebuy

function renderIncludedAccessories() {
  const items = Rebuy.Cart.items();

  const cartItems = document.querySelectorAll(
    '[data-smartcart-items] > .rebuy-cart__flyout-item'
  );

  items.forEach((item, index) => {
    const cartItem = cartItems[index];

    if (!cartItem) return;

    cartItem.querySelector('.included-accessories')?.remove();

    const value =
      item.product?.metafields?.custom?.included_accessories ?? null;

    if (!value) return;

    let accessories;

    try {
      accessories = JSON.parse(value);
    } catch (error) {
      console.warn('Invalid included_accessories:', value);
      return;
    }

    if (!Array.isArray(accessories) || !accessories.length) return;

    const visibleAccessories = accessories.slice(0, 2);
    const remainingCount = accessories.length - 2;

    const accessoriesText = visibleAccessories.join(', ');

    const moreText =
      remainingCount > 0 ? `, +${remainingCount} more` : '';

    const accessoriesEl = document.createElement('div');

    accessoriesEl.className = 'included-accessories';

    accessoriesEl.innerHTML = `
      <span>Includes:</span> ${accessoriesText}${moreText}
    `;

    const quantityEl = cartItem.querySelector(
      '.rebuy-cart__flyout-item-quantity'
    );

    if (quantityEl) {
      quantityEl.parentNode.insertBefore(accessoriesEl, quantityEl);
    }
  });
}
function renderGiftWithPurchase() {
  const items = Rebuy.Cart.items();

  const footer = document.querySelector(
    '[data-rebuy-cart-anchor="footer"]'
  );

  if (!footer) return;

  // Remember current collapsible state before re-render
  const existingToggle = footer.querySelector(
    '.rebuy-custom-text__toggle'
  );

  const wasExpanded =
    existingToggle?.getAttribute('aria-expanded') === 'true';

  footer.querySelector('.rebuy-gift-with-purchase')?.remove();

  const gifts = [];
  const discounts = new Map();

  items.forEach((item) => {
    const properties = item.properties || {};

    // -----------------------------
    // Gift with Purchase
    // -----------------------------
    const hasGiftWithPurchase =
      properties._attribution === 'Rebuy Gift with Purchase';

    if (hasGiftWithPurchase) {
      const title = item.product?.title;

      if (title && !gifts.includes(title)) {
        gifts.push(title);
      }

      return;
    }

    // -----------------------------
    // Discounts
    // -----------------------------
    const itemDiscounts = item.discounts || [];

    itemDiscounts.forEach((discount) => {
      const title = discount.title;

      if (!title || title === 'Free Gift' || title === 'Free Gift!!') {
        return;
      }

      const amount = Number(discount.amount) || 0;

      if (discounts.has(title)) {
        discounts.set(title, discounts.get(title) + amount);
      } else {
        discounts.set(title, amount);
      }
    });
  });

  const discountEntries = [...discounts.entries()];

  const totalDiscount = discountEntries.reduce(
    (total, [, amount]) => total + amount,
    0
  );

  let discountHTML = '';

  if (discountEntries.length > 2) {
    discountHTML = `
      <div class="rebuy-purchase__text">
        <span>Discounts applied</span>
        <span class="gift-text">-$${(totalDiscount / 100).toFixed(2)}</span>
      </div>
    `;
  } else {
    discountHTML = discountEntries
      .map(
        ([title, amount]) => `
          <div class="rebuy-purchase__text">
            <span>Discount ‘${title}’</span>
            <span class="gift-text">-$${(amount / 100).toFixed(2)}</span>
          </div>
        `
      )
      .join('');
  }

  const giftElement = document.createElement('div');

  giftElement.className = 'rebuy-gift-with-purchase';

  giftElement.innerHTML = `
    <div class="rebuy-custom-text">

      <button
        type="button"
        class="rebuy-custom-text__toggle"
        aria-expanded="${wasExpanded}"
      >
        <span>What's Included</span>
        <span
        class="rebuy-custom-text__icon ${wasExpanded ? 'is-expanded' : ''}"
        aria-hidden="true"
        ></span>
      </button>

      <div
        class="rebuy-custom-text__content"
        ${wasExpanded ? '' : 'hidden'}
      >

        ${
          gifts.length
            ? `
              <div class="rebuy-purchase__text">
                <span>Free gift</span>
                <span class="gift-text">${gifts.join(', ')}</span>
              </div>
            `
            : ''
        }

        <div class="rebuy-purchase__text">
          <span>Free shipping</span>
          <span class="gift-text">Included</span>
        </div>

        ${
          discounts.size
            ? discountHTML
            : `
              <div class="rebuy-purchase__text">
                <span>Promo code</span>
              <span class="gift-text">Can be added at checkout</span>
              </div>
            `
        }

      </div>
    </div>
  `;

  const toggle = giftElement.querySelector(
    '.rebuy-custom-text__toggle'
  );

  const content = giftElement.querySelector(
    '.rebuy-custom-text__content'
  );

  const icon = giftElement.querySelector(
    '.rebuy-custom-text__icon'
  );

  toggle.addEventListener('click', () => {
    const isExpanded =
      toggle.getAttribute('aria-expanded') === 'true';

    toggle.setAttribute(
      'aria-expanded',
      String(!isExpanded)
    );

    content.hidden = isExpanded;
    icon.classList.toggle('is-expanded', !isExpanded);
  });

  footer.prepend(giftElement);
}

// Re-initialize Yotpo, waiting for its script if it isn't loaded yet
function reinitYotpo(attempt = 0) {
  if (window.yotpoWidgetsContainer?.initWidgets) {
    window.yotpoWidgetsContainer.initWidgets();
    return;
  }

  // Retry for up to ~5 seconds (20 x 250ms)
  if (attempt < 20) {
    setTimeout(() => reinitYotpo(attempt + 1), 250);
  }
}

function renderYotpoStars() {
  const items = Rebuy.Cart.items();

  const cartItems = document.querySelectorAll(
    '[data-smartcart-items] > .rebuy-cart__flyout-item'
  );

  let needsInit = false;

  items.forEach((item, index) => {
    const cartItem = cartItems[index];
    const productId = item.product_id;

    if (!cartItem || !productId) return;

    const existing = cartItem.querySelector('.rebuy-cart-yotpo');

    if (existing && existing.dataset.productId === String(productId)) {
      // Widget is there but Yotpo hasn't filled it yet, so re-init
      const widget = existing.querySelector('.yotpo-widget-instance');
      if (widget && !widget.children.length) needsInit = true;
      return;
    }

    existing?.remove();

    const yotpoEl = document.createElement('div');
    yotpoEl.className = 'rebuy-cart-yotpo';
    yotpoEl.dataset.productId = productId;
    yotpoEl.innerHTML = `
      <div
        class="yotpo-widget-instance"
        data-yotpo-instance-id="507700"
        data-yotpo-product-id="${productId}"
      ></div>
    `;

    const anchor =
      cartItem.querySelector('.rebuy-cart__flyout-item-variant-title') ||
      cartItem.querySelector('.rebuy-cart__flyout-item-product-title');

    if (anchor) {
      anchor.insertAdjacentElement('afterend', yotpoEl);
      needsInit = true;
    }
  });

  if (needsInit) reinitYotpo();
}
function updateRebuyCartCustomContent() {
  const items = Rebuy.Cart.items();

  // Remove custom content when cart is empty
  if (!items || !items.length) {
    document
      .querySelectorAll(
        '.included-accessories, .rebuy-gift-with-purchase, .rebuy-cart-yotpo'
      )
      .forEach((el) => el.remove());

    return;
  }
  renderIncludedAccessories();
  renderGiftWithPurchase();
  renderYotpoStars();
}

// Cart changed
document.addEventListener('rebuy:cart.change', () => {
  updateRebuyCartCustomContent();
});

// Smart Cart opened
document.addEventListener('rebuy:smartcart.show', () => {
  updateRebuyCartCustomContent();
});
